<p-table #dt [value]="searchResults" [columns]="cols" responsiveLayout="scroll" [rows]="30" [paginator]="true"
    [rowsPerPageOptions]="[30,60,90]" [showCurrentPageReport]="true" (onPage)="onPageChanged($event)" scrollHeight="800px"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(selection)]="selectedResults"
    selectionMode="multiple" [rowHover]="true" dataKey="anchor">
    <ng-template pTemplate="emptymessage">
        <p class="flex align-items-center justify-content-center p-3 text-lg font-medium no-results-message">No Results Available</p>
    </ng-template>
    <ng-template pTemplate="caption">
        <ng-content></ng-content>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="sticky-header">
            <th pSortableColumn="domain" pTooltip="{{'components.anchorResults.anchorTextTooltip' | translate}}">{{'components.anchorResults.anchorText' | translate}}</th>
            <th pSortableColumn="rank" pTooltip="{{'components.anchorResults.anchorRankTooltip' | translate}}">{{'components.anchorResults.rankHeader' | translate}}</th>
            <th pSortableColumn="referringPages" pTooltip="{{'components.anchorResults.referringPagesTooltip' | translate}}">{{'components.anchorResults.referringPagesHeader' | translate}}</th>
            <th pSortableColumn="referringDomains" pTooltip="{{'components.anchorResults.referringDomainsTooltip' | translate}}">{{'components.anchorResults.referringDomainsHeader' | translate}}</th>
            <th pSortableColumn="backlinks" pTooltip="{{'components.anchorResults.backlinksTooltip' | translate}}">{{'components.anchorResults.backlinksHeader' | translate}}</th>
            <th pSortableColumn="brokenBacklinks" pTooltip="{{'components.anchorResults.brokenBacklinksTooltip' | translate}}">{{'components.anchorResults.brokenBacklinksHeader' | translate}}</th>
            <th pSortableColumn="brokenPages" pTooltip="{{'components.anchorResults.brokenPagesTooltip' | translate}}">{{'components.anchorResults.brokenPagesHeader' | translate}}</th>
            <th pSortableColumn="firstSeen" pTooltip="{{'components.anchorResults.firstSeenTooltip' | translate}}">{{'components.anchorResults.firstSeenHeader' | translate}}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-result let-expanded="expanded">
        <tr>
            <td style="width:20%; min-width:10rem;">
                <span [pTooltip]="result?.anchor">{{result?.anchor | truncate: 50}}</span>
            </td>
            <td style="width:11%; min-width:10rem;">
                {{result?.rank | number:'1.0':'en-US'}}
            </td>
            <td style="width:11%; min-width:10rem;">
                {{result?.referringPages | number:'1.0':'en-US'}}
            </td>
            <td style="width:12%; min-width:10rem;">
                <span class="text-purple-600 cursor-pointer" (click)="getReferringDomains(result)">{{result?.referringDomains | number:'1.0':'en-US'}}</span>
                <!-- <button type="button" style="width:50%;" class="p-button-text" pButton [label]="result?.referringDomains" iconPos="right"
                [icon]="result?.openReferringDomainsDropDown ? 'pi pi-angle-up' : 'pi pi-angle-down'" [pRowToggler]="result" (click)="getReferringDomains(result, 'referringDomains')"></button> -->
            </td>
            <td style="width:10%; min-width:10rem;">
                <span class="text-purple-600 cursor-pointer" (click)="getBacklinks(result)">{{result?.backlinks | number:'1.0':'en-US'}}</span>
                <!-- <button type="button" style="width:50%;" class="p-button-text" pButton [label]="result?.backlinks" iconPos="right"
                [icon]="result?.openBacklinksDropDown ? 'pi pi-angle-up' : 'pi pi-angle-down'" [pRowToggler]="result" (click)="getBacklinks(result, 'backlinks')"></button> -->
            </td>
            <td style="width:11%; min-width:10rem;">
                {{result?.brokenBacklinks | number:'1.0':'en-US'}}
            </td>
            <td style="width:11%; min-width:10rem;">
                {{result?.brokenPages | number:'1.0':'en-US'}}
            </td>
            <td style="width:11%; min-width:10rem;">
                {{result?.firstSeen | date:'short'}}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-data>
        <tr *ngIf="data?.openBacklinksDropDown || data?.openReferringDomainsDropDown">
            <td colspan="8">
                <div class="p-3">
                    <gig-backlinks-results #searchResultsTable [searchResults]="data?.referringPagesBacklinks?.items">
                    </gig-backlinks-results>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
